/**
 * @file
 * @author
 */

export function dataParse(originConfigs = [], display = {}) {
    if (!Array.isArray(originConfigs)) {
        originConfigs = [originConfigs];
    }

    const itemFlag = display.item || [];
    const valueFlag = display.value || [];

    // const configs = JSON.parse(JSON.stringify(originConfigs));
    const configs = originConfigs;
    const len = configs.length;
    if (len > 0) {
        const groupNameList = []; // 右下角目录
        const configList = []; // 最左侧名称以及是否显示
        const formatConfigs = []; // 整理后的数据，整理为一维数组
        const formatInfo = []; // 车型信息

        const listKeys = Object.keys(configs[0].list).sort();

        configs.forEach((item, index) => {
            const list = item.list;
            let tempContent = [];
            let tempConfigList = [];
            listKeys.forEach((val, idx) => {
                const {
                    itemName,
                    content
                } = list[val];

                if (itemFlag.includes(itemName)) {
                    // 如果该项需要展示的的数量为0，那你就不用展示了
                    if (!configs.find(n => n.list[val].display)) {
                        return;
                    }
                }

                // 和 groupNameList 具有相同ID，用于锚点跳转
                tempConfigList.push({
                    itemName,
                    id: `${val}${idx}`
                });

                const tContent = [];
                content.forEach((v, i) => {
                    const {
                        name,
                        type,
                        value,
                        symbol
                    } = v;

                    if (valueFlag.includes(name)) {
                        // 如果该项需要展示的的数量为0，那你就不用展示了
                        if (!configs.find(n => n.list[val].content[i].display)) {
                            return;
                        }
                    }

                    // 不需要展示价钱
                    if (name === '经销商报价(元)') {
                        v.isPrice = true;
                        return;
                    }

                    // 如果不是横排也不是竖排，值可能在 value 上，也可能在 symbol 上
                    if (!type) {
                        v.value = value || symbol;
                    }
                    else {
                        // 对数据做下修复
                        // 如果是横排或竖排，value、symbol比为数组
                        if (!symbol) {
                            if (value === '-') {
                                v.symbol = ['-'];
                                v.value = [];
                            }
                            else {
                                v.symbol = [];
                            }
                        }
                        else if (!Array.isArray(symbol)) {
                            v.symbol = [symbol];
                        }

                        if (!v.value) {
                            v.value = [];
                        }
                        else if (!Array.isArray(v.value)) {
                            v.value = [v.value];
                        }
                    }

                    tempConfigList.push({subName: name});

                    tContent.push(v);
                });

                tempContent.push(
                    {itemName},
                    ...tContent
                );

                // 只需要push一遍就行了
                if (index === 0) {
                    groupNameList.push({
                        itemName,
                        id: `${val}${idx}`
                    });
                }
            });
            // 只需要push一遍就行了
            if (index === 0) {
                configList.push(...tempConfigList);
            }
            formatConfigs[index] = tempContent;
            formatInfo[index] = {
                id: item.id,
                name: item.name,
                referencePrice: item.reference_price,
                brandName: item.brand_name || '',
                seriesName: item.series_name || '',
                modelFullName: item.model_full_name || '',
                seriesId: item.series_id || '',
                askPriceUrl: item.model_ask_price_wise_url
            };
        });

        // 判断diff 与 空值
        configList.forEach((item, index) => {
            if (item.itemName) {
                return;
            }
            let tmpDiff = new Set();
            let tmpEmpty = true;
            formatConfigs.forEach(val => {
                const {
                    value = '',
                    symbol = ''
                } = val[index];
                // 判断是否该行全部为空
                tmpEmpty = tmpEmpty
                    && (value === ''
                    || value === ' '
                    || value === '无'
                    // 对于横排或竖排
                    || (!value.length && !symbol.length));
                // 判断该行是否存在不同
                tmpDiff.add(JSON.stringify({
                    value,
                    symbol: symbol || ''
                }));
            });
            if (tmpEmpty) {
                item.allEmpty = true;
            }
            if (tmpDiff.size === 1 && len > 1) {
                item.diff = true;
            }
        });

        return {
            groupNameList,
            configList,
            formatConfigs,
            formatInfo,
            configs: originConfigs
        };
    }
}
